import { useTranslation, Trans } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { LIBERIS_PRIVACY_POLICY_LINK } from '@repo/shared/constants';

export function LiberisAdditionalAgreementsInfo() {
  const { t } = useTranslation();

  return (
    <ol>
      <li>
        {t('welcomePage.loanApplicationPossible.liberis.agreementsForm.additionalInfo.param1')}
      </li>
      <li>
        {t('welcomePage.loanApplicationPossible.liberis.agreementsForm.additionalInfo.param2')}
      </li>
      <li>
        <Typography>
          {t(
            'welcomePage.loanApplicationPossible.liberis.agreementsForm.additionalInfo.param3.sub1',
          )}
        </Typography>
        <Typography>
          <Trans
            i18nKey="welcomePage.loanApplicationPossible.liberis.agreementsForm.additionalInfo.param3.sub2"
            components={[<Link href="mailto:biznes@przelewy24.pl" />]}
          />
        </Typography>
        <Typography>
          {t(
            'welcomePage.loanApplicationPossible.liberis.agreementsForm.additionalInfo.param3.sub3',
          )}
        </Typography>
        <Typography>
          {t(
            'welcomePage.loanApplicationPossible.liberis.agreementsForm.additionalInfo.param3.sub4',
          )}
        </Typography>
        <Typography>
          {t(
            'welcomePage.loanApplicationPossible.liberis.agreementsForm.additionalInfo.param3.sub5',
          )}
        </Typography>
        <Typography>
          <Trans
            i18nKey="welcomePage.loanApplicationPossible.liberis.agreementsForm.additionalInfo.param3.sub6"
            components={[
              <Link href={LIBERIS_PRIVACY_POLICY_LINK} target="_blank" rel="noopener noreferrer" />,
            ]}
          />
        </Typography>
      </li>
    </ol>
  );
}
